import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Avatar from '../../reusablePreviewComponents/Avatar'
import PageName from '../../reusablePreviewComponents/PageName'
import ButtonIcon from '../../../Buttons/ButtonIcon'
import { ReactComponent as DotsIcon } from '../../../../../assets/icons/dots-menu.svg'

import useStyles from './styles'

const StoryHeader = ({ itemsCount, pageId, elementInProgress }) => {
  const { t } = useTranslation()

  const classes = useStyles({ itemsCount })

  return (
    <div className={classes.adStoriesCardHeader}>
      <div className={classes.storyTimeline}>
        {Array.from({ length: itemsCount }).map((_, index) => (
          <div key={index} className={classes.timeline} />
        ))}
      </div>
      <div className={classes.headerTop}>
        <Avatar pageId={pageId} size={22} backgroundColor={'white'} />
        <div className={classes.info}>
          <div className={classes.name}>
            <PageName elementInProgress={elementInProgress} pageId={pageId} />
          </div>
          <div className={classes.description}>{t('Sponsored')}</div>
        </div>
        <ButtonIcon Icon={DotsIcon} className={classes.dotsButton} />
      </div>
    </div>
  )
}

StoryHeader.propTypes = {
  itemsCount: PropTypes.number,
  pageId: PropTypes.string,
  elementInProgress: PropTypes.string
}

export default StoryHeader
